/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefUserData } from '../../models/api-def-user-data';

export interface UsersGetUsers$Params {

/**
 * Maximum number of users to return (default 20)
 */
  limit?: number;

/**
 * Number of users to skip (for pagination)
 */
  offset?: number;

/**
 * Search by fullNameLower (case-insensitive)
 */
  search?: string;

/**
 * Comma-separated list of user IDs to filter by
 */
  ids?: Array<string>;
}

export function usersGetUsers(http: HttpClient, rootUrl: string, params?: UsersGetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'users'?: Array<ApiDefUserData>;

/**
 * Total number of users matching the query
 */
'total'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, usersGetUsers.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('search', params.search, {});
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'users'?: Array<ApiDefUserData>;
      
      /**
       * Total number of users matching the query
       */
      'total'?: number;
      }>;
    })
  );
}

usersGetUsers.PATH = '/users';
